import { EmergencyHomeFilled } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React from 'react';
import styles from "./ErrorMessage.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorMessage = ({
  className,
  id,
  identifier,
  children
}) => {
  const classes = classNames(styles.errorMessage, className);
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: classes,
    "aria-live": "assertive",
    "data-testid": identifier ? `error-${identifier}` : undefined,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.errorIcon,
      children: /*#__PURE__*/_jsx(EmergencyHomeFilled, {})
    }), /*#__PURE__*/_jsx("div", {
      className: styles.errorText,
      children: children
    })]
  });
};